var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "div",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.getHBLInfo } },
            [
              _vm._v(
                _vm._s(_vm.$t("SeaExport.CopyEnglishDescriptionOfGoodsFromHBL"))
              )
            ]
          )
        ],
        1
      ),
      _c(
        "cargo-rich-textarea",
        _vm._g(
          _vm._b(
            {
              attrs: { disabled: _vm.disabled },
              model: {
                value: _vm.job.cargoEnglishName,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cargoEnglishName", $$v)
                },
                expression: "job.cargoEnglishName"
              }
            },
            "cargo-rich-textarea",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }